module.exports = __webpack_public_path__ + "static/media/insurance-benefits-non-tca.7cb141a6.aif";